// extracted by mini-css-extract-plugin
export var active = "_31-2";
export var errorDot = "_31-3";
export var sideNavContainer = "_31-0";
export var sideNavLink = "_31-1";